import { render, staticRenderFns } from "./DocIcon.vue?vue&type=template&id=9f20d456"
import script from "./DocIcon.vue?vue&type=script&lang=ts"
export * from "./DocIcon.vue?vue&type=script&lang=ts"
import style0 from "./DocIcon.vue?vue&type=style&index=0&id=9f20d456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports